import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  closeModalDialog,
  showSnackNotificationAction,
} from "../../../../../../actions/layoutActions";
import { CreateUnitOfMeasure } from "./CreateUnitOfMeasure";
import {
  performCreateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";
import { unitOfMeasureDataComponentId } from "../UnitOfMeasureContainer";
import { useCreateProcessRequests } from "../../../../../hooks/useProcessRequest";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { convertServerErrorToFormikErrors } from "../../../../../../utils/formValidationUtils";
import propTypes from "../../../../../../constants/propTypes";

const CreateUnitOfMeasureContainer = ({
  dataComponent,
  performCreateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
}) => {
  useCreateProcessRequests(dataComponent, {
    onSuccess: () => {
      showSnackNotificationAction("Unit of Measure created successfully.");
      setReload(unitOfMeasureDataComponentId, true);
      closeModalDialog();
    },
    onError: error => {
      const convertedError = convertServerErrorToFormikErrors(error);
      showSnackNotificationAction(convertedError.name);
    },
  });

  const handleCreateUnitOfMeasure = values => {
    performCreateRequest(unitOfMeasureDataComponentId, values);
  };

  return (
    <CreateUnitOfMeasure
      handleCreateUnitOfMeasure={handleCreateUnitOfMeasure}
      closeModalDialog={closeModalDialog}
    />
  );
};

CreateUnitOfMeasureContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  performCreateRequest: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    dataComponent: getDataComponent(unitOfMeasureDataComponentId, state),
  };
};

const mapDispatchToProps = {
  performCreateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateUnitOfMeasureContainer);
